export const MIN_POLYGON_POINTS = 3;
